import { Radio } from "antd";

interface RenderRecurrenceOptionsProps {
  recurrence: string;
  weeklyDays: string;
  monthlyDay: number;
  errors: any;
  setFieldValue: (field: string, value: any) => void;
}

function RenderRecurrenceOptions({
  recurrence,
  weeklyDays,
  monthlyDay,
  errors,

  setFieldValue,
}: Readonly<RenderRecurrenceOptionsProps>) {
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  switch (recurrence) {
    case "daily":
      return (
        <div className="">
          <p className="mb-3 text-sm text-purple-600">
            Specify duration for which the subscription should be sent
          </p>
        </div>
      );
    case "weekly":
      return (
        <div className="mb-10 space-y-4">
          <p className="text-sm text-purple-600">
            Specify the day of the week on which the subscription should be sent
          </p>
          <div className="flex flex-row items-center gap-4 divide-x-4">
            <div className="mt-3 divide-x-2">
              <label
                htmlFor="recurrenceFrequency-weekly"
                className="text-sm font-medium text-gray-700"
              >
                Day in the week
              </label>
              <div className="grid min-w-fit grid-cols-2 gap-2 sm:grid-cols-4">
                {days.map((day) => (
                  <label key={day} className="flex items-center space-x-2">
                    <Radio
                      className="h-5 w-5 text-purple-500 text-purple-600 accent-purple-500"
                      checked={weeklyDays === day}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFieldValue("weeklyDays", day);
                        }
                      }}
                    />
                    <span className="text-sm text-gray-700">{day}</span>
                  </label>
                ))}
              </div>
              {errors.weeklyDays && (
                <div className="text-red-500">
                  {errors.weeklyDays as string}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    case "monthly":
      return (
        <div className="space-y-6">
          <p className="text-sm text-purple-600">
            Specify months and days on which the subscription should be sent
          </p>
          <div className="mb-7 flex items-center">
            <div className="ml-3 flex items-center">
              <label className="mr-2 text-sm font-medium text-gray-700">
                On day
              </label>
              <select
                value={monthlyDay}
                className="w-16 text-center"
                onChange={(e) =>
                  setFieldValue("monthlyDay", Number(e.target.value))
                }
              >
                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
              <span className="ml-2 text-lg text-gray-700">of every month</span>
            </div>
          </div>
          {errors.monthlyDay && (
            <div className="text-red-500">{errors.monthlyDay as string}</div>
          )}
        </div>
      );
    default:
      return null;
  }
}
export default RenderRecurrenceOptions;
